// // export default RecentUploads;
// import React, { useState } from "react";
// import Logo from "../Assets/images/fav-icon.png";
// import UnderReview from "../Assets/images/under-review.png"
// import Rejected from "../Assets/images/rejected.png"


// const RecentUploads = ({ approvalstatus }) => {

//     if (approvalstatus === null || approvalstatus === undefined) {
//         return (
//             <div className="home-one-wrapper-inner" style={{ marginTop: "100px" }}>
//                 <div className="home-bot-chat temp-width" style={{ maxWidth: "80%" }}>
//                     <p className="text-center">Checking account status...</p>
//                 </div>
//             </div>
//         );
//     }


//     const isUnderReview = approvalstatus !== 3;
    
//     return (
//         <>
//             {approvalstatus !== 3 ? (
//                 <div className="home-one-wrapper-inner" style={{ marginTop: "100px" }}>
//                     <div className="home-bot-chat temp-width" style={{ maxWidth: "80%" }}>




//                         <div className="confirm-mgs-wrapper">
//                             <h5 className="welNote mb-0 text-center">
//                                 <img className="welnote-logo me-2" src={Logo} alt="welnote-logo" />
//                                 Hi {localStorage.getItem("username") || 'Alden'}
//                             </h5>
//                             <img src={UnderReview} alt="review" className="review-img mx-auto" />

//                             <h3>Thank you for creating your <br className="d-none d-md-block" /> account with <span>AttestaAI</span>.</h3>
//                             <p>Your account is currently under review and will be approved within 12 to 24 hours. You will receive a confirmation email once the approval process is complete.</p>
//                         </div>
//                     </div>
//                 </div>
//             ) : {approvalstatus === 2 || 0 ? (
//                 <div className="home-one-wrapper-inner" style={{ marginTop: "100px" }}>
//                     <div className="home-bot-chat temp-width" style={{ maxWidth: "80%" }}>




//                         <div className="confirm-mgs-wrapper">
//                             <h5 className="welNote mb-0 text-center">
//                                 <img className="welnote-logo me-2" src={Logo} alt="welnote-logo" />
//                                 Hi {localStorage.getItem("username") || 'Alden'}
//                             </h5>
//                             <img src={Rejected} alt="review" className="reject-img mx-auto" />

//                             <h3>Thank you for <br /> signing up with  <span>AttestaAI</span>.</h3>
//                             <p>After the review process, we’re unable to approve your account. We understand this may be disappointing and appreciate your interest in our platform.</p>
//                         </div>

//                     </div>
//                 </div>): null)}
//         </>
//     );
// };

// export default RecentUploads;
import React from "react";
import Logo from "../Assets/images/fav-icon.png";
import UnderReview from "../Assets/images/under-review.png";
import Rejected from "../Assets/images/rejected.png";

const RecentUploads = ({ approvalstatus }) => {

  if (approvalstatus === null || approvalstatus === undefined) {
    return (
      <div className="home-one-wrapper-inner" style={{ marginTop: "100px" }}>
        <div className="home-bot-chat temp-width" style={{ maxWidth: "80%" }}>
          <p className="text-center">Checking account status...</p>
        </div>
      </div>
    );
  }

  if (approvalstatus === 2 || approvalstatus === 0) {
    return (
      <div className="home-one-wrapper-inner" style={{ marginTop: "100px" }}>
        <div className="home-bot-chat temp-width" style={{ maxWidth: "80%" }}>
          <div className="confirm-mgs-wrapper">
            <h5 className="welNote mb-0 text-center">
              <img className="welnote-logo me-2" src={Logo} alt="welnote-logo" />
              Hi {localStorage.getItem("username") || 'Alden'}
            </h5>
            <img src={UnderReview} alt="review" className="review-img mx-auto" />
            <h3>Thank you for creating your <br className="d-none d-md-block" /> account with <span>AttestaAI</span>.</h3>
            <p>Your account is currently under review and will be approved within 12 to 24 hours. You will receive a confirmation email once the approval process is complete.</p>
          </div>
        </div>
      </div>
    );
  }

  if (approvalstatus === 3) {
    return (
      <div className="home-one-wrapper-inner" style={{ marginTop: "100px" }}>
        <div className="home-bot-chat temp-width" style={{ maxWidth: "80%" }}>
          <div className="confirm-mgs-wrapper">
            <h5 className="welNote mb-0 text-center">
              <img className="welnote-logo me-2" src={Logo} alt="welnote-logo" />
              Hi {localStorage.getItem("username") || 'Alden'}
            </h5>
            <img src={Rejected} alt="review" className="reject-img mx-auto" />
            <h3>Thank you for <br /> signing up with  <span>AttestaAI</span>.</h3>
            <p>After the review process, we’re unable to approve your account. We understand this may be disappointing and appreciate your interest in our platform.</p>
          </div>
        </div>
      </div>
    );
  }

  // fallback for any other status
  return null;
};

export default RecentUploads;
